import { ChangeDetectionStrategy, Component, ContentChild, EventEmitter, Inject, InjectionToken, Input, Output, TemplateRef, ViewChild } from "@angular/core";
import { NzSafeAny } from "ng-zorro-antd/core/types";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzTabComponent } from "ng-zorro-antd/tabs";
import { UiTabLinkDirective, UiTabLinkTemplateDirective } from "./directives/tab-link.directive";
import { UiTabDirective } from "./directives/tab.directive";
import { UiTabColorType, UiTabTemplateContext } from "./models/tab.models";

/**
 * Used to provide a tab set to a tab without causing a circular dependency.
 */
export const NZ_TAB_SET = new InjectionToken<NzSafeAny>("NZ_TAB_SET");

@Component({
  selector: "ui-tab",
  exportAs: "uiTab",
  templateUrl: "./tab.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class UiTabComponent extends NzTabComponent {
  @Input("uiTitle") public nzTitle: string | TemplateRef<UiTabTemplateContext> = "";
  @Input("uiClosable") @InputBoolean() public nzClosable = false;
  @Input("uiCloseIcon") public nzCloseIcon: string | TemplateRef<NzSafeAny> = "close";
  @Input("uiDisabled") @InputBoolean() public nzDisabled = false;
  @Input("uiForceRender") @InputBoolean() public nzForceRender = false;
  @Input() public uiTabColor: UiTabColorType;
  @Output("uiSelect") public readonly nzSelect = new EventEmitter<void>();
  @Output("uiDeselect") public readonly nzDeselect = new EventEmitter<void>();
  @Output("uiClick") public readonly nzClick = new EventEmitter<void>();
  @Output("uiContextmenu") public readonly nzContextmenu = new EventEmitter<MouseEvent>();

  @ContentChild(UiTabLinkTemplateDirective, { static: false }) public nzTabLinkTemplateDirective!: UiTabLinkTemplateDirective;
  @ContentChild(UiTabDirective, { static: false, read: TemplateRef }) public template: TemplateRef<void> | null = null;
  @ContentChild(UiTabLinkDirective, { static: false }) public linkDirective!: UiTabLinkDirective;
  @ViewChild("contentTemplate", { static: true }) public contentTemplate!: TemplateRef<NzSafeAny>;

  constructor(@Inject(NZ_TAB_SET) public closestTabSet: NzSafeAny) {
    super(closestTabSet);
  }
}
